// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__EqscX","initials-svg":"Footer_initials-svg__VEBpy"};